export default __webpack_public_path__ + "static/media/real-life-TOM1L.6973017c.mp3";